import {Card, List as AntList} from 'antd';
import React, {useMemo, FC} from 'react';

import {EFieldType, IListEntityMeta} from 'entities/metadata';
import {IListEntityData} from 'modules/data/data-types';
import {combineString} from 'shared/utils/combine-string';

import {ListItem} from './list-item';
import {getListValue} from './utils/list-utils';

import './list.less';

interface IListProps {
    listData?: IListEntityData;
    meta?: IListEntityMeta;
    showTitle?: boolean;
}

export const List: FC<IListProps> = ({
    listData,
    meta,
    showTitle = true,
}: IListProps) => {
    const title = useMemo(() => {
        if (!meta?.titleStructure) {
            return meta?.title;
        }
        return combineString(meta?.titleStructure, listData?.data);
    }, [meta?.title, meta?.titleStructure]);

    return (
        <Card title={showTitle ? title : ''}>
            <AntList>
                {meta?.fields?.map(fieldMeta => {
                    const {key, type, stringStructure} = fieldMeta;
                    if (fieldMeta.type === EFieldType.ICON_LINK) {
                        return (
                            <div key={key}>
                                <ListItem
                                    meta={fieldMeta}
                                />
                            </div>
                        );
                    }
                    const value = getListValue(key, type, stringStructure, listData?.data);
                    if (!value) return null;
                    return (
                        <div key={key}>
                            <ListItem
                                meta={fieldMeta}
                                value={value}
                            />
                        </div>
                    );
                })}
            </AntList>
        </Card>
    );
};
